export const translations = {
  editarF: {
    pt: 'Editar',
    en: 'Edit',
    de: 'Bearbeiten',
    es: 'Editar',
  },
};